<button mat-raised-button color="primary" [matMenuTriggerFor]="reportMenu">
    <mat-icon>arrow_drop_down</mat-icon>
    &nbsp;Reports
</button>
<mat-menu #reportMenu="matMenu">
    @for (report of reports; track report.name) {
        @if (isVisible(report)) {
            <button mat-menu-item [disabled]="isDisabled(report)" (click)="openReport(report)">
                <mat-icon>{{ canPreview(report) ? 'picture_as_pdf' : 'file_download' }}</mat-icon>
                <span>{{ report.name }}</span>
            </button>
        }
    }
</mat-menu>
